import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AlertNotificactions, AlertNotificactionsCount, SendNotification } from '../layouts/full/interface/headers.interface';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/enviroments';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  constructor(private http: HttpClient) {}

  getNotifications(alertsMinuteS: number, alertsCuoteS: number): Observable<Array<AlertNotificactions>> {
    const endpoint = `${environment.apiUrl}/notification/GetNotification`;
    const params = new HttpParams()
      .set('lengthListMinutes', alertsMinuteS.toString())
      .set('lengthListQuotes', alertsCuoteS.toString());
  
    return this.http.get<Array<AlertNotificactions>>(endpoint, { params });
  }
  
  getNotificationsPendingCount(): Observable<AlertNotificactionsCount> {
    const endpoint = `${environment.apiUrl}/notification/GetCountNotificationPending`;
    return this.http.get<AlertNotificactionsCount>(endpoint);
  }

  createNotifications(request:SendNotification):Observable<any> {
    console.log(request);
    const endpoint = `${environment.apiUrl}/Notification/AddNotification`;
    console.log(endpoint);
    return this.http.post<any>(endpoint, request);
  }

  sendWhatsappNotification(data:any):Observable<any>{
    const endpoint = `${environment.apiUrl}/Notification/SendNotificationToWhatsappClient`;
    const postData = {
      "templateName": data.templateName,
      "to": Number.parseInt(data.to),
      "bodyParams": JSON.stringify(data.bodyParams),
      "buttonParam": data.buttonParam.toString()
    }
    return this.http.post<any>(endpoint, data);
  }
}
